import './styles.css';

let pixelBlobApp = null;

export async function mountPixelBlob(target, options = {}) {
    if (!target) return;
    if (pixelBlobApp) return;
    const module = await import('./core/App.ts');
    const App = module.App;
    pixelBlobApp = new App(target, options);
    await pixelBlobApp.start();
}

export function unmountPixelBlob() {
    if (pixelBlobApp && typeof pixelBlobApp.destroy === 'function') {
        pixelBlobApp.destroy();
    }
    pixelBlobApp = null;
}
